import { CalculationTypeEnum } from '../../api/models/calculation-type-enum';

export enum CalculationTypeRoutes {
  ONE_SLOPE = '1-apă',
  TWO_SLOPES = '2-ape',
  FOUR_SLOPES = '4-ape',
  MANUAL = 'manual',
  SHAPES = 'forme-geometrice',
  FENCE_SLAT = 'sipca-metalica-gard',
  FENCE_PANEL = 'panou-gard',
}

export enum CalculationStepRoutes {
  MODELS = 'modele',
  MEASUREMENTS = 'măsurători',
  SKETCHES = 'schițe',
  ACCESSORIES = 'accesorii',
}
export const routeToRoofTypeMap = {
  [CalculationTypeRoutes.ONE_SLOPE]: CalculationTypeEnum.OneSlope,
  [CalculationTypeRoutes.TWO_SLOPES]: CalculationTypeEnum.TwoSlopes,
  [CalculationTypeRoutes.FOUR_SLOPES]: CalculationTypeEnum.FourSlopes,
  [CalculationTypeRoutes.MANUAL]: CalculationTypeEnum.Custom,
  [CalculationTypeRoutes.SHAPES]: CalculationTypeEnum.CustomShape,
  [CalculationTypeRoutes.FENCE_SLAT]: CalculationTypeEnum.FenceSlat,
  [CalculationTypeRoutes.FENCE_PANEL]: CalculationTypeEnum.FencePanel,
};

export const roofTypeToRouteMap = Object.entries(routeToRoofTypeMap).reduce((object: any, [key, value]) => {
  object[value] = key;
  return object;
}, {}) as unknown as Record<CalculationTypeEnum, CalculationTypeRoutes>;

export const autoCalculationRouteToStepMap: any = {
  [CalculationStepRoutes.MODELS]: 1,
  [CalculationStepRoutes.MEASUREMENTS]: 2,
  [CalculationStepRoutes.SKETCHES]: 3,
  [CalculationStepRoutes.ACCESSORIES]: 4,
};
export const manualCalculationRouteToStepMap: any = {
  [CalculationStepRoutes.MODELS]: 1,
  [CalculationStepRoutes.MEASUREMENTS]: 2,
  [CalculationStepRoutes.ACCESSORIES]: 3,
};
export const routeToCalculationStepMap = {
  [CalculationTypeRoutes.SHAPES]: manualCalculationRouteToStepMap,
  [CalculationTypeRoutes.MANUAL]: manualCalculationRouteToStepMap,
  [CalculationTypeRoutes.FENCE_SLAT]: manualCalculationRouteToStepMap,
  [CalculationTypeRoutes.FENCE_PANEL]: manualCalculationRouteToStepMap,
  [CalculationTypeRoutes.ONE_SLOPE]: autoCalculationRouteToStepMap,
  [CalculationTypeRoutes.TWO_SLOPES]: autoCalculationRouteToStepMap,
  [CalculationTypeRoutes.FOUR_SLOPES]: autoCalculationRouteToStepMap,
};
export const getStepToCalculationStepRouteMap = (calculationRoute: CalculationStepRoutes | any) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return Object.entries(routeToCalculationStepMap[calculationRoute]).reduce((object: any, [key, value]) => {
    object[value as any] = key;
    return object;
  }, {});
};

export const addToCartCalculations = [
  {
    linkText: 'Acoperiș în o apa',
    link: ['/calcul', CalculationTypeRoutes.ONE_SLOPE, CalculationStepRoutes.MODELS],
    title: 'Acoperiș în o apa',
    topNavTitle: 'Calculator 1 apa',
    subText: 'Calcul automat pentru tablă și accesoriile necesare unui acoperiș în 1 apă.',
    imgLink: 'assets/calculation-types/navigation/acoperis-1-apa.svg',
    roofType: CalculationTypeEnum.OneSlope,
  },
  {
    linkText: 'Acoperiș în două ape',
    link: ['/calcul', CalculationTypeRoutes.TWO_SLOPES, CalculationStepRoutes.MODELS],
    title: 'Acoperiș în două ape',
    topNavTitle: 'Calculator 2 ape',
    subText: 'Calcul automat pentru tablă și accesoriile necesare unui acoperiș în 2 ape.',
    imgLink: 'assets/calculation-types/navigation/acoperis-2-ape.svg',
    roofType: CalculationTypeEnum.TwoSlopes,
  },
  {
    linkText: 'Acoperiș în patru ape',
    link: ['/calcul', CalculationTypeRoutes.FOUR_SLOPES, CalculationStepRoutes.MODELS],
    title: 'Acoperiș în patru ape',
    topNavTitle: 'Calculator 4 ape',
    subText: 'Calcul automat pentru tablă și accesoriile necesare unui acoperiș în 4 ape.',
    imgLink: 'assets/calculation-types/navigation/acoperis-4-ape.svg',
    roofType: CalculationTypeEnum.FourSlopes,
  },
  {
    linkText: 'Comandă manuală',
    link: ['/calcul', CalculationTypeRoutes.MANUAL, CalculationStepRoutes.MODELS],
    title: 'Comandă manuală',
    topNavTitle: 'Calcul manual',
    subText: 'Calcul manual pentru tablă și accesorii, cantitățile sunt introduse manual.',
    imgLink: 'assets/calculation-types/navigation/comanda-manuala.svg',
    roofType: CalculationTypeEnum.Custom,
  },
  {
    linkText: 'Șipcă gard',
    link: ['/calcul', CalculationTypeRoutes.FENCE_SLAT, CalculationStepRoutes.MODELS],
    title: 'Calculator gard sipca metalica',
    topNavTitle: 'Șipcă gard',
    subText: 'Calcul pentru gard de tip sipca metalica',
    imgLink: 'assets/calculation-types/navigation/fence-slats.svg',
    roofType: CalculationTypeEnum.FenceSlat,
  },
  {
    linkText: 'Calcul cu forme',
    link: ['/calcul', CalculationTypeRoutes.SHAPES, CalculationStepRoutes.MODELS],
    title: 'Calcul cu forme',
    subText: 'Calcul automat pentru tablă bazat pe formele geometrice introduse în calculator.',
    imgLink: 'assets/calculation-types/navigation/calcul-cu-forme.svg',
    roofType: CalculationTypeEnum.CustomShape,
  },
];

export const rainSystemCalculation = {
  linkText: 'Sistem Pluvial',
  link: ['/sistem-pluvial'],
  title: 'Sistem Pluvial',
  subText: 'Calcul pentru sistemul pluvial, cantitățile elementelor trebuie introduse manual.',
  imgLink: 'assets/calculation-types/navigation/sistem-pluvial.svg',
};

export const approximationCalculation = {
  linkText: 'Preț aproximativ',
  link: ['/calcul-aproximativ'],
  title: 'Preț aproximativ',
  subText: 'Află prețul aproximativ pe baza tipului de acoperiș, model, finisaj și suprafață.',
  imgLink: 'assets/calculation-types/navigation/pret-aproximativ.svg',
  roofType: CalculationTypeEnum.Custom,
};

export const calculationTypes = [...addToCartCalculations, approximationCalculation];

export const noModelCalculationTypes = [
  rainSystemCalculation,
  {
    linkText: 'Contact',
    link: ['/custom-orders'],
    title: 'Comenzi personalizate',
    imgLink: 'assets/calculation-types/navigation/comanda-personalizata.svg',
    subText: `Pentru a plasa o comandă personalizată vă rugăm să ne contactați la
      <a href="tel:0740101510">0740 101 510</a> /
      <a href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a>`,
  },
  {
    linkText: 'Listă prețuri',
    link: ['/produse'],
    title: 'Produse',
    subText: 'Listă cu toate produsele ce le comercializăm cu prețurile lor.',
    imgLink: 'assets/calculation-types/navigation/produse.svg',
  },
];
